import { Link } from "react-router-dom";
import { Panel, Th, Td } from "@/components/ui-kit";
import { StatusBadge } from "@/components/StatusBadge";

const MAP = { released: ["released", "940 released"], on_hold: ["exception", "On hold"], received: ["received", "Received"], duplicate: ["duplicate", "Duplicate"], error: ["error", "Error"] };

export const SapResults = ({ results }) => (
  <Panel title="Import results" testId="sap-results">
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead className="border-b border-slate-800"><tr><Th>SAP SO</Th><Th>Amazon PO</Th><Th>Result</Th><Th>Detail</Th></tr></thead>
        <tbody className="divide-y divide-slate-800/70">
          {results.map((r, i) => (
            <tr key={i} data-testid={`sap-result-${i}`}>
              <Td className="font-mono">{r.sales_order}</Td>
              <Td className="font-mono">{r.order_id ? <Link to={`/orders/${r.order_id}`} className="text-sky-300 hover:underline">{r.po_number}</Link> : r.po_number}</Td>
              <Td><StatusBadge status={MAP[r.status]?.[0] || r.status} label={MAP[r.status]?.[1]} testId={`sap-result-status-${i}`} /></Td>
              <Td className="text-xs text-slate-400">{r.message}</Td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </Panel>
);
